<template>
  <div class="container">
      <Layout>
          <Row class="hint-img">
              <img src="../assets/image/img-activate.png"/>
          </Row>
          <Row>
              <div class="hint">
                  <P>{{$t('message.A_nonactivate_prohint')}} {{text.name}}</P>
                  <P>{{$t('message.A_nonactivate_SNhint')}} {{text.batch_no}}</P>
              </div>
              <P class="text-cur">{{$t('message.A_nonactivate_cur')}}</P>
              <P class="text-act">{{$t('message.A_nonactivate_act')}}</P>
              <P class="text-cur">{{$t('message.A_nonactivate_time',{count:text.count})}}</P>
          </Row>
          <Row>
              <Button class="btn" long type="primary" @click="handleClick()">
                  {{$t('message.A_nonactivate_btn')}}
              </Button>
              <p class="text-cur">{{$t('message.A_nonactivate_scan')}}</p>
          </Row>
      </Layout>
  </div>
</template>

<script>
  
  export default {
      name: "A_nonactivate",
      data() {
          return {
              text: {
                  name: '',
                  count: '',
                  batch_no: ''
              }
          }
      },
      created() {
          this.getText();
          this.text.batch_no = this.prefixInteger(this.text.batch_no, 8);
      },
      methods: {
          handleClick() {
              this.$router.push({
                  name: 'Scan', params: {
                      data: {
                          device: this.text.device,
                          info_code: this.text.info_code,
                      }
                  }
              });
          },
          prefixInteger(num, n) {
              return (Array(n).join(0) + num).slice(-n);
          },
          getText() {
              let _me = this;
              _me.text = _me.$route.params.data;
              if (_me.text == undefined) {
                  let list = sessionStorage.getItem("text");
                  _me.text = JSON.parse(list);
              } else {
                  sessionStorage.setItem("text", JSON.stringify(_me.text));
              }
          }
      }
  }
</script>

<style scoped>
  .hint {
      margin: 0.4rem 0;
  }
  
  .btn {
      margin: 2.34rem 0 0.14rem;
  }
</style>
